import { render, staticRenderFns } from "./TablePicker.vue?vue&type=template&id=4804ac6c&scoped=true"
import script from "./TablePicker.vue?vue&type=script&lang=js"
export * from "./TablePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4804ac6c",
  null
  
)

export default component.exports